export default {
  INITIAL: 'initial',
  PRESETS: 'presets',
};
